import create from 'zustand';
import { CancerConfig, Config } from '../configs/cancerConfig';
import { ConfigTypes } from '../hooks/useConfig';

export interface ConfigurationStoreValues extends ConfigStoreKeys {
	cancer: CancerConfig[] | undefined;
	behavior: Config[] | undefined;
	ethnicities: Config[] | undefined;
	race: Config[] | undefined;
	setting: Config[] | undefined;
	menopausal: Config[] | undefined;
	recurrence: Config[] | undefined;
	recurrence_areas: Config[] | undefined;
	areas_of_metastasis: Config[] | undefined;
	sex: Config[] | undefined;
	event_history_status: Config[] | undefined;
	panel_type: Config[] | undefined;
	treatment_history_status: Config[] | undefined;
}

export interface ConfigurationStoreProps extends ConfigStoreKeys {
	cancer: CancerConfig[] | undefined;
	behavior: Config[] | undefined;
	ethnicities: Config[] | undefined;
	race: Config[] | undefined;
	setting: Config[] | undefined;
	menopausal: Config[] | undefined;
	recurrence: Config[] | undefined;
	recurrence_areas: Config[] | undefined;
	areas_of_metastasis: Config[] | undefined;
	sex: Config[] | undefined;
	event_history_status: Config[] | undefined;
	panel_type: Config[] | undefined;
	treatment_history_status: Config[] | undefined;
	setConfig: (key: StoreConfigurationTypes, config: CancerConfig[] | Config[]) => void;
}

export type ConfigStoreKeys = {
	[x in StoreConfigurationTypes]?: CancerConfig[] | Config[] | undefined;
};

export type StoreConfigurationTypes = 'cancer' | ConfigTypes;

const useConfigurationStore = create<ConfigurationStoreProps>((set) => ({
  cancer: undefined,
  behavior: undefined,
  ethnicities: undefined,
  race: undefined,
  setting: undefined,
  menopausal: undefined,
  recurrence: undefined,
  recurrence_areas: undefined,
  areas_of_metastasis: undefined,
  sex: undefined,
  event_history_status: undefined,
  panel_type: undefined,
  treatment_history_status: undefined,
  setConfig: (key: StoreConfigurationTypes, config: CancerConfig[] | Config[]) => {
    set((previous) => ({
      ...previous,
      [key]: config
    }));
  }
}));

export { useConfigurationStore as default };
